import { TextField } from "@mui/material";
import clsx from "clsx";
import Text from "../../styleguide/Text";
import { DateTimePicker as MuiDateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import moment, { Moment } from "moment";

interface DatePicker {
  label?: string;
  placeholder?: string;
  handleChangeDate?: (newValue: Date | null) => void;
  value?: Date | string | null;
  disabled?: boolean;
  className?: string;
  withVerticalSpacer?: boolean;
  isRequired?: boolean;
  touched?: boolean;
  error?: string;
  textInputClassName?: string;
  dateFormat?: string;
  fullWith?: boolean;
  gutterBottom?: boolean;
  maxDate?: Date;
  minDate?: Date;
  withClearData?: boolean;
  currentTimezone?: string;
  withAmPm?: boolean;
  size?: any;
}

const DateTimePicker = ({
  label,
  placeholder,
  handleChangeDate,
  value,
  disabled,
  className,
  withVerticalSpacer,
  isRequired,
  textInputClassName,
  dateFormat = "DD/MM/YYYY HH:mm",
  fullWith = true,
  gutterBottom = true,
  maxDate,
  minDate,
  withClearData,
  touched,
  error,
  size = "medium",
  withAmPm = false,
}: DatePicker) => {
  const parsedValue = value ? moment(value) : null;
  const parsedMinDate = minDate ? moment(minDate) : undefined;
  const parsedMaxDate = maxDate ? moment(maxDate) : undefined;

  const handleChange = (newValue: Moment | null) => {
    if (withClearData) {
      handleChangeDate && handleChangeDate(newValue?.toDate() || null);
      return;
    }
    if (newValue) {
      handleChangeDate && handleChangeDate(newValue.toDate());
    }
  };

  return (
    <div
      className={`${fullWith ? "w-100" : ""} ${
        withVerticalSpacer ? "px-1" : ""
      } ${className}`}>
      <MuiDateTimePicker<Moment>
        componentsProps={{
          actionBar: {
            actions: withClearData ? ["clear"] : [],
          },
        }}
        inputFormat={dateFormat}
        value={parsedValue || null}
        disableMaskedInput
        onChange={handleChange}
        disabled={disabled}
        minDateTime={parsedMinDate}
        maxDateTime={parsedMaxDate}
        ampm={withAmPm ? true : false}
        className={clsx(
          "form-control form-control-solid mb-3 mb-lg-0",
          { "is-invalid": error && touched },
          {
            "is-valid": !error && touched,
          },
          textInputClassName,
        )}
        renderInput={(params) => (
          <div className={`d-flex flex-column ${gutterBottom ? "mb-7" : ""}`}>
            {label && (
              <label
                className={`${
                  isRequired && "required"
                } fs-6 mb-2 form-label fw-bolder text-dark`}>
                {label}
              </label>
            )}
            <TextField
              sx={{
                "& fieldset": { border: "none" },
              }}
              size={size}
              variant="outlined"
              placeholder={placeholder}
              {...params}
              onKeyDown={(e) => {
                e.preventDefault();
              }}
            />
          </div>
        )}
      />
      {touched && error && (
        <div>
          <Text variant="body1" color="red" role="alert" className="mt-1">
            {error}
          </Text>
        </div>
      )}
    </div>
  );
};

export default DateTimePicker;
